import React from 'react'
import './styles.scss'
import { RootState } from '@AppState/redux-store'
import { useSelector } from 'react-redux'
import { ANIMATION_CONFIG_MAP } from '@Animation/animation-map'

const CLASS_NAME = 'gby-k2g-animation-background'

export const AnimationBackground = React.memo(() => {
  const { animationIdentifier } = useSelector((state: RootState) => state.animation)
  const { backgroundUrl } = ANIMATION_CONFIG_MAP[animationIdentifier].appSettings

  return (
    <div
      className={CLASS_NAME}
      style={{
        backgroundImage: `url("${backgroundUrl}")`,
      }}>
      <div className={`${CLASS_NAME}__top-background-fade`} />
      <div className={`${CLASS_NAME}__bottom-background-fade`} />
    </div>
  )
})
